import { createSlice } from '@reduxjs/toolkit';

const user = createSlice({
  name: 'user',
  initialState: {
    token: null,
    uuid: null,
    isLoadingUser: false,
    providerUsers: {},
    isOwner: false,
    locations: null,
  },
  reducers: {
    userRequest(state) {
      state.isLoadingUser = true;
    },
    userSuccess(state, { payload }) {
      const provider = payload.data.providerUsers[0];
      return {
        token: state.token,
        ...payload.data,
        providerUsers: provider,
        isOwner: !!(payload.data.providerUsers?.[0]?.role?.value === 'Owner'),
        isLoadingUser: false,
      };
    },
    userFailure(state) {
      state.isLoadingUser = false;
    },
    userSetCredentials(state, { payload }) {
      state.token = payload.token;
      state.uuid = payload.uuid;
    },
    setUserLocations(state, { payload }) {
      state.locations = payload;
    },
  },
});

const { actions, reducer } = user;

export const {
  userRequest,
  userSuccess,
  userFailure,
  userSetCredentials,
  setUserLocations,
} = actions;

export default reducer;
